import type {SensitivePayload} from "./sensitive-payload.interface";

/** Whether `payload` is a SensitivePayload (has `clearSensitiveValues()`). */
export function isSensitivePayload(payload: unknown): payload is SensitivePayload {
    return typeof payload === 'object' && payload !== null
        && typeof (payload as Partial<SensitivePayload>).clearSensitiveValues === 'function';
}
